import {
    TESTE_OP_01,
    TESTE_OP_02
  } from '../actions/testeAction';
  
  const initialState = {
    testeObj: [
        {
            title: 'Nike Air Max',
            quantity: 142,
            sold: 124,
            total: '$ 4 234',
            img: `${process.env.PUBLIC_URL}/img/shoes/01.png`,
        },
        {
            title: 'Nike Air Max222222222',
            quantity: 142,
            sold: 124,
            total: '$ 4 234',
            img: `${process.env.PUBLIC_URL}/img/shoes/01.png`,
        }
    ],
    testeObj2: {}
  };
  
  const testeReducer = (state = initialState, action) => {
    switch (action.type) {
      case TESTE_OP_01: {
        const obj = state.testeObj[action.index];
        return { ...state, testeObj2: obj };
      }
      case TESTE_OP_02: {
        const obj = [...state.testeObj];
        obj[action.index] = action.testeObj2;
        return { ...state, testeObj: obj };
      }
      default:
        return state;
    }
  };
  
  export default testeReducer;
  